import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import { guid } from '@/mixins/guid';

export default Vue.component('renew-domain', {
  template: require('./template.html'),
  name: 'renew-domain',
  mixins: [guid],
  props: ['current-domain', 'expiry', 'reset-expiry'],
  computed: {
    ...mapGetters(['priceSource', 'currentUser', 'currentSite']),
  },
  data() {
    return {
      renewDomain: false,
      autoRenew: false,
      renewError: false,
      manualRenew: false,
      loading: false,
      purchaseLengths: [],
      tlds: [],
      selectedRenewLength: 1,
      successfulRenew: false,
    };
  },
  created() {
    this.renewDomain = false;
    this.purchaseLengths = this.priceSource.years;
    this.tlds = this.priceSource.tlds;
  },
  methods: {
    setRenewType(type, o) {
      this[type] = !this[type];
      this[o] = false;
    },
    async submitRenewDomain() {
      this.loading = true;
      const domain = `${this.currentDomain.name}${this.currentDomain.tld}`;
      let expYear = new Date(this.expiry.date);
      expYear = expYear.getFullYear();

      const notif = {
        id: this.guid(),
        type: 'success',
        message: `Successfully renewed ${domain} for ${this.selectedRenewLength} years!
        Please allow a few minutes for these changes to take effect.`,
      };
      try {
        await this._SEND([{
          name: 'renewDomain',
          payload: {
            currentSite: {
              _id: this.currentSite._id,
            },
            currentUser: this.currentUser,
            currentDomain: this.currentDomain,
            newYearAmount: this.selectedRenewLength,
            domain,
            expYear,
          },
        }]);
        this.$log.debug('Successfully renewed domain: ', domain);
        this.$emit('reset-expiry');
      } catch (e) {
        this.renewError = `${e.message || e}. This has been reported.`;
        notif.type = 'error';
        notif.message = `${e.message || e}. This has been reported.`;
        this.$log.error(e);
        await this._reportError({
          error: e,
          fn: 'submitRenewDomain',
        });
      } finally {
        this.loading = false;
        this.successfulRenew = true;
        this.$store.dispatch('addNotification', notif);
        this._trackEvent({
          type: 'renew_domain',
          meta: {
            site_name: this.currentSite.alias,
            site_type: this.currentSite.type,
            site_tier: this.currentSite.tier,
            domain_name: this.currentDomain.name,
            tld: this.currentDomain.tld,
            renew_length: this.selectedRenewLength,
          },
        });
      }
    },
    getPrice() {
      const fee = this.priceSource.fees.purchaseDomain;
      const tld = _.find(this.tlds, { tld: this.currentDomain.tld.split('.')[1] });
      const total = tld.price * this.selectedRenewLength;
      return total + fee;
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/admin/websites/edit-site/domains/edit-domain/renew-domain/index.js